
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/borders",
      function () {
        return require("private-next-pages/system/borders.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/borders"])
      });
    }
  